class NoActiveOrganisationError extends Error {
  constructor() {
    super("error.noActiveOrganisation");
  }
}

export default NoActiveOrganisationError;
